import * as React from "react";

import { cn } from "../../../../lib/utils";

const Input = React.forwardRef(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-love-pink bg-background_lv px-3 py-2 text-base ring_lv-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground_lv placeholder:text-muted_lv-foreground focus-visible:outline-none focus-visible:ring_lv-2 focus-visible:ring_lv-ring focus-visible:ring_lv-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };